/** Settings are strings from the API; the default matches SettingsUtils. */
export function logoBackgroundEnabled(value) {
  if (value == null || value === '') return true
  return value === true || String(value).trim().toLowerCase() === 'true'
}
